
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-knowledge-base",
      function () {
        return require("private-next-pages/ai-knowledge-base.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-knowledge-base"])
      });
    }
  